import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";

@Component({
	selector: "task-types-list",
	templateUrl: "task-types-list.component.html",
	styleUrls: ["task-types-list.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TaskTypesListComponent {
	// @ts-expect-error TS7008
	@Input() options;
	@Output() selectTaskType = new EventEmitter<string>();
}
